import { _ } from "../../../../core/polyglot/polyglot.js";
import {
	required,
	validateAll,
} from "../../../../core/widgets/forms/validators.js";
import dialog from "../../../../core/widgets/dialog.js";
import FormBuilder from "../../../../core/widgets/forms/FormBuilder.js";
import jQuery from "jquery";

/**
 * `renameEntrywidget` is used to rename an entry.
 * It displays a popup asking the user the new name of the entry
 * he wants to rename. In case of name conflict, direct feedback
 * is provided as a red label.
 *
 * It should only be used through the proper command.
 */
export default function renameEntryDialog(command, my) {
	my ||= {};

	const that = dialog({}, my);

	my.title = _("Rename");
	my.showFooter = false;

	const selectedItem = command.getEntry();
	const folder = selectedItem.parent();

	const newEntry = {};
	let input;

	my.content = new FormBuilder({
		model: newEntry,
		validateOnBlur: false,
		saveAction: renameEntry,
		saveLabel: _("Rename"),
		cancelAction: that.hide,
		dataTestName: "confirm-rename",
	});

	that.show = function () {
		my.show();
		input = jQuery("#renameField").find("input");
		input.select();
		input.focus();
	};

	my.validateName = function (originalName) {
		folder.children().forEach((each) => {
			if (each.name() !== originalName) {
				return;
			}
			throw _(
				"This name is already used by a file or a folder in this directory",
			);
		});
	};

	my.content.input({
		id: "renameField",
		value: selectedItem.name(),
		attribute: "name",
		label: _("New name"),
		validator: validateAll(required(), my.validateName),
	});

	function renameEntry() {
		that.hide();
		command.setNewName(newEntry.name);
		command.doPerform();
	}

	return that;
}
